import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Slider } from '@mui/material';
import React from 'react';
import { useCategoryStore } from '../../../../store/category';
import { useGlobalStore } from '../../../../store/global';
import { formatPrice } from '../../../../utils';
export default function AttributePrice() {
    const max = useCategoryStore((state) => state.category.price.max);
    const currency = useGlobalStore((state) => state.config.currency);
    const clearTrigger = useCategoryStore((state) => state.clearTrigger);
    const setFilter = useCategoryStore((state) => state.setFilter);
    const [priceRange, setPriceRange] = React.useState([0, max]);
    React.useEffect(() => {
        setPriceRange([0, max]);
    }, [clearTrigger]);
    const handlePriceChange = (event, value) => {
        const price = value;
        setFilter({ price_min: price[0], price_max: price[1] });
    };
    return (_jsxs("div", { className: "values d-flex flex-column", children: [_jsxs("div", { className: "price-box-row", children: [_jsx("input", { name: 'min', className: "price-box min", value: formatPrice(priceRange[0], currency), disabled: true }), _jsx("input", { name: 'max', className: "price-box max", value: formatPrice(priceRange[1], currency), disabled: true })] }), _jsx(Slider, { getAriaLabel: () => 'Price range', value: priceRange, min: 0, max: max, onChange: (e, value, x) => setPriceRange(value), onChangeCommitted: handlePriceChange, valueLabelDisplay: "auto", getAriaValueText: (value) => `${value} ${currency.symbol}` })] }));
}
